import { Stack, Suggestion, Suggestions } from "@altimateai/lego";
import { ApiHelper, useQuery } from "../../../api/index";
import { useChatContext } from "../../ChatProvider";
import { useAgentChat } from "../../hooks/useAgentChat";
import { useEffect } from "react";

const Followup = () => {
  const { currentSessionId, urls } = useChatContext();
  const { sendMessage } = useAgentChat();
  const { data, refetch } = useQuery<{ questions: string[] }>({
    queryFn: () => ApiHelper.get(urls?.followupPath!, { session_id: currentSessionId }),
    enabled: false,
  });

  useEffect(() => {
    if (currentSessionId && urls?.followupPath) {
      refetch();
    }
    // adding refetch as deps will trigger api call repeatedly
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSessionId, urls?.followupPath]);

  if (!data?.questions?.length || !urls?.followupPath || !currentSessionId) {
    return null;
  }

  const handleSuggestionClick = (suggestion: string) => {
    sendMessage({ message: suggestion });
  };

  return (
    <Stack direction="column" gap="sm" className="al-mt-4">
      {/* Label matching Figma design: font-size/s (12px), font-weight 500, color #7A899E */}
      <p className=" al-text-xs al-font-medium al-text-[#7A899E] al-leading-4">Ask a follow up:</p>

      {/* Horizontal scrollable suggestions using AI SDK Elements */}
      {/* Figma specs: gap 4px, white bg, #D5DBE4 border, #374C6A text, py-2 px-4 */}
      <Suggestions>
        {data.questions.map(question => (
          <Suggestion key={question} suggestion={question} onClick={handleSuggestionClick} />
        ))}
      </Suggestions>
    </Stack>
  );
};

export default Followup;
